import { BaseObject } from "../core/BaseObject";

export class ServiceItem extends BaseObject {
	id: number;
	name: string;
	number: string;
	rate: string;
	cost: number;
	serviceCode: string;
	description: string;
	requestTypeNames: string;
	requestCategoryIds: number[] = [];
	articleNumber: string;
	serviceRequestTypes: ServiceRequestTypeItem[] = [];
	discountLimit: number;
}

export class ServiceRequestTypeItem {
	serviceId: number;
	sku: string;
	serviceName: string;
	requestTypeId: number;
	requestTypeName: string;
	requestCategoryId: number;
	requestCategoryName: string;
	isDefault: boolean;
	disabled: boolean;
	cost: number;

	uid: string;
}

